// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e20ed8df","839":"199a226b"}[chunkId] + ".chunk.js";
};